
import React, { useContext, useState } from "react"
import Resizer from "react-image-file-resizer";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../context/CurrentUserContext";

const CreateCourse = () => {
  const [values, setValues] = useState({
    name: "",
    description: "",
    price: "9.99",
    uploading: false,
    paid: "paid",
    loading: false,
    category:""
  })
  const { currentUser } = useContext(CurrentUserContext);
  const userId = currentUser?._id;
  const navigate = useNavigate();
  const [isPaid, setIsPaid] = useState<boolean>(false);
  const [preview, setPreview] = useState<string>("");
  const [image, setImage] = useState({});
  const children = [];
  for (let index = 9.99; index <= 100.99; index++) {
    children.push(<option value={index.toFixed(2)} key={index.toFixed(2)}>${index.toFixed((2)) }</option>)
  }
  
  const handleChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const target = e.target as HTMLTextAreaElement
    setValues({ ...values, [target?.name]: target?.value });
  }
  const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    let file = e.target.files[0];
    const loadedFile = URL.createObjectURL(e.target.files[0])

    setPreview(loadedFile);
    setValues({ ...values, loading: true })
    Resizer.imageFileResizer(file, 720, 500, "JPEG", 100, 0, async(uri) => {
      try {
        let response = await fetch("https://api-j06q.onrender.com/api/course/uploadImage", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json'
          },
          body: JSON.stringify({ image: uri })
        })
        const data = await response.json();
        
        setImage(data)
        setValues({ ...values, loading: false })
        
      } catch (error) {
        console.log(error);
        
        setValues({ ...values, loading: false })
      }
    })
    
    

  }
  const handleSubmit = async(e:React.SyntheticEvent) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api-j06q.onrender.com/api/course/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json'
        },
        body: JSON.stringify({ ...values, image, userId })
      })
      const data = await response.json();
      console.log(data);
      
      if (response.ok) {
        alert(data);
        navigate("/instructor");
      } else {
        alert(data)
      }
    } catch (error) {
      console.log(error);
      
    }
    
  }

  const handleSelect = () => {
    setIsPaid(!isPaid)
    if (isPaid) {
      setValues({ ...values, paid: "paid" })
      
    } else {
      setValues({ ...values, paid: "free", price: "0" })
    }
    
  }
  const handleSelectedPrice = (e: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(e.target.value);
    const v = e.target.value;
    setValues({...values, price:v})
    
  }

  const removeImage = async() => {
    try {
      setValues({ ...values, loading: true })
      let response= await fetch("https://api-j06q.onrender.com/api/course/removeImage", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json'
        },
        body: JSON.stringify({ image })
      })
      const data = await response.json();
      console.log(data);
      setPreview("");
      setImage({})
      
      setValues({ ...values, loading: false })

    } catch (error) {
      console.log(error);
      
    }
    
  }


  return (
    
    <div>
      <h1>Create Course</h1>
      <div>
        <form onSubmit={handleSubmit}>
          <div>
            <input type="text" name="name" placeholder="name" value={values.name} onChange={handleChange} />
          </div>
          <div>
            <textarea name="description" placeholder="Description" cols={7} rows={7} value={values.description} onChange={handleChange}></textarea>
          </div>
          <div>
            <select onChange={handleSelect}>
              <option value={values.paid}>Paid</option>
              <option value={values.paid}>Free</option>
            </select>
          </div>
          {!isPaid && 
            <div>
              <select defaultValue="9.99" onChange={handleSelectedPrice}>
                {children}
              </select>
            </div>
          }
          <div>
            <input type="text" name="category" placeholder="Category" value={values.category} onChange={handleChange} />
          </div>
          <div>
          <label>{values.loading ? "Uploading" : "Image Upload"}</label>
            <input type="file" name="image" placeholder="Select Image" id="myFile" onChange={handleImage} accept="image/*" />
            {preview && 
              <div>
                <img width={200} src={preview} alt="imagePreview" />
                <button onClick={removeImage}>Remove Img</button>
              </div>
              
            }
          </div>

          <div>
            <button onClick={handleSubmit} disabled={values.loading || values.uploading}>{ values.loading ? "Saving..." : "Save & Continue"}</button>
          </div>
        </form>
      </div>
      <pre>{JSON.stringify(values, null, 4)}</pre>
      <pre>{ JSON.stringify(image, null, 4)}</pre>
    </div>
  )
}

export default CreateCourse